import { SelectOption } from 'components/Organization/Select';
import { roleToText } from 'helpers/role';

// TODO: Refactor InviteUsers to call this function to share logic between AddMembers and InviteUsers
const lrRoles: SelectOption[] = [
  { value: 'lr_educator', text: roleToText('lr_educator') },
  { value: 'lr_coach', text: roleToText('lr_coach') }
];

const dcRoles: SelectOption[] = [
  { value: 'data_entry', text: roleToText('data_entry') },
  { value: 'observer', text: roleToText('observer') },
  { value: 'supervisor', text: roleToText('supervisor') }
];

const iiRoles: SelectOption[] = [
  { value: 'ii_admin', text: roleToText('ii_admin') },
  { value: 'ii_coach', text: roleToText('ii_coach') },
  { value: 'ii_educator', text: roleToText('ii_educator') }
];

const subscriptionProductRoles: Record<string, SelectOption[]> = {
  learning_resources: lrRoles,
  data_collection: dcRoles,
  instant_insights: iiRoles,
  class_connect: []
};

export function getSubscriptionProductRoles(
  productName: string
): SelectOption[] {
  return subscriptionProductRoles[productName] ?? [];
}

export function subscriptionRequiresRole(productName: string): boolean {
  return getSubscriptionProductRoles(productName).length > 0;
}
